import { FC } from 'react';
import './style.scss';

interface IProps {
  title: string;
  type?: 'some' | 'multi';
  onClick: () => void;
  className?: string;
}

const ModalActionButton: FC<IProps> = ({ title, type = 'multi', onClick, className = '' }: IProps): JSX.Element => {
  if (type === 'some') {
    return (
      <button onClick={onClick} className={`custom-modal__button-action custom-modal__button-action_some ${className}`}>
        {title}
      </button>
    );
  }

  return (
    <button onClick={onClick} className={`custom-modal__button-action custom-modal__button-action_multi letter-spacing-12 ${className}`}>
      {title}
    </button>
  );
};

export default ModalActionButton;
